module.exports = __webpack_public_path__ + "img/emoji_32.03a7c422.png";